import { useDispatch, useSelector } from "react-redux";
import { blogFiltered } from "../../features/filter/filterSlice";

const Filter = () => {
    const dispatch = useDispatch();

    const { filter } = useSelector((state) => state.filter);

    const handleChange = (value) => {
        dispatch(blogFiltered(value));
    };

    return (
        <div className="sidebar-content">
            <h4>Filter</h4>
            <div className="radio-group">
                <div>
                    <input
                        type="radio"
                        name="filter"
                        id="lws-all"
                        checked={filter === "all"}
                        className="radio"
                        onChange={() => handleChange("all")}
                    />
                    <label htmlFor="lws-all">All</label>
                </div>
                <div>
                    <input
                        type="radio"
                        name="filter"
                        id="lws-saved"
                        checked={filter === "saved"}
                        className="radio"
                        onChange={() => handleChange("saved")}
                    />
                    <label htmlFor="lws-saved">Saved</label>
                </div>
            </div>
        </div>
    );
};

export default Filter;
